export default __webpack_public_path__ + "static/media/shoppingBasket.42aeaddf.svg";